import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

// ใช้ Custom Input เพื่อแสดงปี พ.ศ. บนช่อง input
// const CustomInputDate = React.forwardRef(({ value, onClick }, ref) => (
const CustomInputDate = React.forwardRef(
  ({ value, onClick, formatDateToBuddhist }, ref) => {
    // console.log(props)
    console.log(value);
    // console.log(ref)
    return (
      <button
        className="bg-white border bg-primary p-2 rounded"
        onClick={onClick}
        ref={ref}
      >
        {formatDateToBuddhist(value)}
      </button>
    );
  }
);

const DatePickerBuddhist = ({ selected, onChange, dateFormat }) => {
  // const [startDate, setStartDate] = useState(new Date());

  // ฟังก์ชันแปลงวันที่ให้แสดงปี พ.ศ.
  const formatDateToBuddhist = (dateText) => {
    const date = new Date(dateText);
    const buddhistYear = date.getFullYear() + 543;

    console.log("dateText=", dateText);
    console.log("date=", date);
    console.log("buddhistYear=", buddhistYear);
    const month = date.toLocaleString("th-TH", { month: "long" });
    const day = date.getDate();

    let thai_date = `${day} ${month} ${buddhistYear}`;

    console.log("thai_date=", thai_date);
    return thai_date;
  };

  return (
    <div>
      <DatePicker
        locale="th"
        selected={selected || null}
        onChange={(date) => onChange(date)}
        dateFormat={dateFormat} // format พื้นฐาน
        customInput={
          <CustomInputDate
            value={selected}
            formatDateToBuddhist={formatDateToBuddhist}
          />
        }
      />
    </div>
  );
};

export default DatePickerBuddhist;
